/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Download_All_PhotosInputs */

const en_download_all_photos = /** @type {(inputs: Download_All_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download All Photos`)
};

const es_download_all_photos = /** @type {(inputs: Download_All_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargar Todas las Fotos`)
};

const fr_download_all_photos = /** @type {(inputs: Download_All_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Télécharger Toutes les Photos`)
};

const de_download_all_photos = /** @type {(inputs: Download_All_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Fotos herunterladen`)
};

const ja_download_all_photos = /** @type {(inputs: Download_All_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべての写真をダウンロード`)
};

const zh_download_all_photos = /** @type {(inputs: Download_All_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载所有照片`)
};

const ar_download_all_photos = /** @type {(inputs: Download_All_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تنزيل جميع الصور`)
};

const id_download_all_photos = /** @type {(inputs: Download_All_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unduh Semua Foto`)
};

const it_download_all_photos = /** @type {(inputs: Download_All_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scarica Tutte le Foto`)
};

const ru_download_all_photos = /** @type {(inputs: Download_All_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скачать Все Фото`)
};

const pt_download_all_photos = /** @type {(inputs: Download_All_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descarregar Todas as Fotos`)
};

const ko_download_all_photos = /** @type {(inputs: Download_All_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모든 사진 다운로드`)
};

/**
* | output |
* | --- |
* | "Download All Photos" |
*
* @param {Download_All_PhotosInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const download_all_photos = /** @type {((inputs?: Download_All_PhotosInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Download_All_PhotosInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_download_all_photos(inputs)
	if (locale === "es") return es_download_all_photos(inputs)
	if (locale === "fr") return fr_download_all_photos(inputs)
	if (locale === "de") return de_download_all_photos(inputs)
	if (locale === "ja") return ja_download_all_photos(inputs)
	if (locale === "zh") return zh_download_all_photos(inputs)
	if (locale === "ar") return ar_download_all_photos(inputs)
	if (locale === "id") return id_download_all_photos(inputs)
	if (locale === "it") return it_download_all_photos(inputs)
	if (locale === "ru") return ru_download_all_photos(inputs)
	if (locale === "pt") return pt_download_all_photos(inputs)
	return ko_download_all_photos(inputs)
});